import * as Yup from 'yup';

export default Yup.object().shape({
  event: Yup.object().shape({
    date: Yup.date().required(
      'We need your event date to check if suppliers are available.'
    ),
  }),
});
